import React, { useState, useEffect } from "react";
import { Variables } from "../../Variables1/Variables";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Row,
  Col,
  Modal,
  Button,
  Form,
  Card,
  FormCheck,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import CustomSnipper from "../../components/customSnipper";
import Util from "../../Classes/Util";
import Cookies from "js-cookie";

function LanguagesList(props) {
  const navigate = useNavigate();
  const token = Cookies.get("token");
  const [Permissions, setPermissions] = useState(
    Util.decrypt(localStorage.getItem("rpmRRTLx12"))
  );

  const [loader, setLoader] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [search, SetSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [addModalShow, SetAddModalShow] = useState(false);
  const [languageAddToDb, setLanguageAddToDb] = useState({
    LanguageId: 0,
    LanguageName: "",
    LanguageSuffix: "",
    IsDefault: false,
  });

  const [languageUpdateToDb, setLanguageUpdateToDb] = useState({
    LanguageId: 0,
    LanguageName: "",
    LanguageSuffix: "",
    IsDefault: false,
  });
  const [updateModalShow, setUpdateModalShow] = useState(0);

  // Get Languages
  const GetLanguages = async () => {
    setLoader(true);
    let response = await fetch(Variables.API_URL + "Language/GetLanguages", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    let result = await response.json();
    if (response.status === 200) {
      setLanguages(result);
      setFilteredData(result);
    }
    setLoader(false);
  };

  // handle Search
  const handleSearch = (event) => {
    let value = event.target.value.toLowerCase();
    let result = [];
    SetSearch(value);
    result = languages.filter((data) => {
      return data.LanguageName.toLowerCase().search(value) !== -1 || data.LanguageSuffix.toLowerCase().search(value) !== -1;
    });
    setFilteredData(result);
  };

  // Clear language Add To Db
  function ClearlanguageAddToDb() {
    SetAddModalShow(false);
    setLanguageAddToDb({
      LanguageId: 0,
      LanguageName: "",
      LanguageSuffix: "",
      IsDefault: false,
    });
  }

  // Set Add To Db
  function SetAddToDb() {
    SetAddModalShow(true);
    setLanguageAddToDb({
      LanguageId: 0,
      LanguageName: "",
      LanguageSuffix: "",
      IsDefault: false,
    });
  }

  // Set Update ToDb
  function SetUpdateToDb(id, name,suffix, isDefault) {
    setUpdateModalShow(id);
    SetUpdateToDb({
      LanguageId: id,
      LanguageName: name,
      LanguageSuffix: suffix,
      IsDefault: isDefault,
    });
  }

  // Clear language Update To Db
  function ClearlanguageUpdateToDb() {
    setUpdateModalShow(0);
    setLanguageUpdateToDb({
      LanguageId: 0,
      LanguageName: "",
      LanguageSuffix: "",
      IsDefault: false,
    });
  }

  // handle Add Inputs
  function handleAddInputs(e) {
    const { value } = e.target;
    var element;
    if (value === "") {
      element = document.getElementById("LanguageNameToAdd");
      element.classList.add("is-invalid");
    } else {
      element = document.getElementById("LanguageNameToAdd");
      element.classList.remove("is-invalid");
    }
    setLanguageAddToDb((prevState) => ({
      ...prevState,
      ["LanguageName"]: value,
    }));
  }

  // handle Add Suffix Inputs
  function handleAddSuffixInputs(e) {
    const { value } = e.target;
    var element;
    if (value === "") {
      element = document.getElementById("LanguageSuffixToAdd");
      element.classList.add("is-invalid");
    } else {
      element = document.getElementById("LanguageSuffixToAdd");
      element.classList.remove("is-invalid");
    }
    setLanguageAddToDb((prevState) => ({
      ...prevState,
      ["LanguageSuffix"]: value,
    }));
  }

  // Check input validity
  function IsValidToAdd() {
    var hasError = false;
    var element;
    if (
      languageAddToDb.LanguageName === null ||
      languageAddToDb.LanguageName === ""
    ) {
      element = document.getElementById("LanguageNameToAdd");
      element.classList.add("is-invalid");
      hasError = true;
    }

    if (
      languageAddToDb.LanguageSuffix === null ||
      languageAddToDb.LanguageSuffix === ""
    ) {
      element = document.getElementById("LanguageSuffixToAdd");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (hasError === true) {
      return false;
    } else {
      return true;
    }
  }

  // Add new Language
  const AddNewLanguage = async () => {
    var Valid = IsValidToAdd();
    if (Valid) {
      let response = await fetch(
        Variables.API_URL + "Language/AddNewLanguage",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            LanguageId: languageAddToDb.LanguageId,
            LanguageName: languageAddToDb.LanguageName,
            LanguageSuffix: languageAddToDb.LanguageSuffix,
            IsDefault: languageAddToDb.IsDefault,
          }),
        }
      );
      let result = await response.json();
      if (response.status === 200) {
        toast.success(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        SetAddModalShow(false);
        setLanguageAddToDb({
          LanguageId: 0,
          LanguageName: "",
          LanguageSuffix: "",
          IsDefault: false,
        });
        GetLanguages();
      } else {
        toast.error(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } else {
      toast.error("Please Select required input", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  // handle Updatee Inputs
  function handleUpdateInputs(e) {
    const { value } = e.target;
    var element;
    if (value === "") {
      element = document.getElementById("LanguageNameToUpdate");
      element.classList.add("is-invalid");
    } else {
      element = document.getElementById("LanguageNameToUpdate");
      element.classList.remove("is-invalid");
    }
    setLanguageUpdateToDb((prevState) => ({
      ...prevState,
      ["LanguageName"]: value,
    }));
  }

  // handle Updatee Sufix Inputs
  function handleUpdateSuffixInputs(e) {
    const { value } = e.target;
    var element;
    if (value === "") {
      element = document.getElementById("LanguageSuffixToUpdate");
      element.classList.add("is-invalid");
    } else {
      element = document.getElementById("LanguageSuffixToUpdate");
      element.classList.remove("is-invalid");
    }
    setLanguageUpdateToDb((prevState) => ({
      ...prevState,
      ["LanguageSuffix"]: value,
    }));
  }

  const HandleUpdateIsDefault = () => {
    if (languageUpdateToDb.IsDefault === true) {
      setLanguageUpdateToDb((prevState) => ({
        ...prevState,
        IsDefault: false,
      }));
    } else {
      setLanguageUpdateToDb((prevState) => ({
        ...prevState,
        IsDefault: true,
      }));
    }
  };

  // Check input validity
  function IsValidToUpdate() {
    var hasError = false;
    var element;
    if (
      languageUpdateToDb.LanguageName === null ||
      languageUpdateToDb.LanguageName === ""
    ) {
      element = document.getElementById("LanguageNameToUpdate");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (
      languageUpdateToDb.LanguageSuffix === null ||
      languageUpdateToDb.LanguageSuffix === ""
    ) {
      element = document.getElementById("LanguageSuffixToUpdate");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (hasError === true) {
      return false;
    } else {
      return true;
    }
  }

  // Update Language
  const UpdateLanguage = async () => {
    var Valid = IsValidToUpdate();
    if (Valid) {
      let response = await fetch(
        Variables.API_URL + "Language/UpdateLanguage",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            LanguageId: languageUpdateToDb.LanguageId,
            LanguageName: languageUpdateToDb.LanguageName,
            LanguageSuffix: languageUpdateToDb.LanguageSuffix,
            IsDefault: languageUpdateToDb.IsDefault,
          }),
        }
      );
      let result = await response.json();
      if (response.status === 200) {
        toast.success(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setUpdateModalShow(0);
        setLanguageUpdateToDb({
          LanguageId: 0,
          LanguageName: "",
          LanguageSuffix: "",
          IsDefault: false,
        });
        GetLanguages();
      } else {
        toast.error(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } else {
      toast.error("Please Select required input", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  useEffect(() => {
   
 

      GetLanguages();
  }, []);


  return (
    <div>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">Languages List</h4>
              </div>
              {Permissions.ManageLanguages === true && (
                <Button variant="primary" onClick={() => SetAddToDb()}>
                  Add New Language
                </Button>
              )}
            </Card.Header>
            <Card.Body className="px-0">
              <Form.Control
                id="Search"
                name="Search"
                placeholder="Search"
                type="text"
                className="allignCenter"
                onChange={handleSearch}
              />
              {loader === true ? (
                <CustomSnipper />
              ) : (
                <div className="table-responsive">
                  <table
                    id="user-list-table"
                    className="table table-striped"
                    role="grid"
                    data-toggle="data-table"
                  >
                    <thead>
                      <tr className="ligth">
                        <th></th>
                        <th>Language Name</th>
                        <th>Suffix</th>
                        <th>IsDefault</th>
                        <th min-width="100px">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.map((tdata, index) => (
                        <tr key={index}>
                          <td className="text-center">{index + 1}</td>
                          <td>{tdata.LanguageName}</td>
                          <td>{tdata.LanguageSuffix}</td>
                          <td>
                            <span
                              className={
                                tdata.IsDefault === false
                                  ? "badge bg-danger"
                                  : "badge bg-success"
                              }
                            >
                              Default Language
                            </span>
                          </td>
                          <td>
                            {Permissions.ManageLanguages === true && (
                              <div className="flex align-items-center list-user-action">
                                <Link
                                  className="btn btn-sm btn-icon btn-success"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title=""
                                  data-original-title="Edit"
                                  to={"#"}
                                  onClick={() => {
                                    setLanguageUpdateToDb({
                                      LanguageId: tdata.LanguageId,
                                      LanguageName: tdata.LanguageName,
                                      LanguageSuffix: tdata.LanguageSuffix,
                                      IsDefault: tdata.IsDefault,
                                    });
                                    setUpdateModalShow(tdata.LanguageId);
                                  }}
                                >
                                  <span className="btn-inner">
                                    <svg
                                      width="20"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      ></path>
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      ></path>
                                      <path
                                        d="M15.1655 4.60254L19.7315 9.16854"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      ></path>
                                    </svg>
                                  </span>
                                </Link>{" "}
                                <Modal
                                  show={updateModalShow == tdata.LanguageId}
                                  onHide={() => ClearlanguageUpdateToDb()}
                                >
                                  <Modal.Header closeButton>
                                    <Modal.Title as="h5">
                                      Update Language :{" "}
                                      {languageUpdateToDb.LanguageName}
                                    </Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body>
                                    <Row>
                                      <Form.Group className="col-md-12 form-group">
                                        <Form.Label htmlFor="lname">
                                          Language Name:
                                        </Form.Label>
                                        <Form.Control
                                          id="LanguageNameToUpdate"
                                          name="LanguageNameToUpdate"
                                          placeholder="Language Name"
                                          type="text"
                                          value={
                                            languageUpdateToDb.LanguageName
                                          }
                                          onChange={handleUpdateInputs}
                                        />
                                      </Form.Group>
                                    </Row>
                                    <Row>
                                      <Form.Group className="col-md-12 form-group">
                                        <Form.Label htmlFor="lname">
                                          Language Suffix:
                                        </Form.Label>
                                        <Form.Control
                                          id="LanguageSuffixToUpdate"
                                          name="LanguageSuffixToUpdate"
                                          placeholder="Language Suffix"
                                          type="text"
                                          value={
                                            languageUpdateToDb.LanguageSuffix
                                          }
                                          onChange={handleUpdateSuffixInputs}
                                        />
                                      </Form.Group>
                                    </Row>
                                    <Row>
                                      <Form.Group className="col-lg-6 col-md-6 col-sm-12 form-group">
                                        <Form.Label htmlFor="fname">
                                          Is Default :
                                        </Form.Label>
                                        <Form.Check className="mb-3 form-check">
                                          <FormCheck.Input
                                            type="checkbox"
                                            className=""
                                            id="IsDefautToUodate"
                                            checked={
                                              languageUpdateToDb.IsDefault
                                            }
                                            onChange={(e) =>
                                              HandleUpdateIsDefault()
                                            }
                                          />
                                          <FormCheck.Label
                                            className=""
                                            htmlFor="exampleCheck1"
                                          >
                                            Is Default
                                          </FormCheck.Label>
                                        </Form.Check>
                                      </Form.Group>
                                    </Row>
                                  </Modal.Body>
                                  <Modal.Footer>
                                    <Button
                                      variant="secondary"
                                      onClick={() => setUpdateModalShow(0)}
                                    >
                                      Close
                                    </Button>
                                    <Button
                                      variant="primary"
                                      onClick={() => UpdateLanguage()}
                                    >
                                      Save changes
                                    </Button>
                                  </Modal.Footer>
                                </Modal>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <Modal
                    show={addModalShow}
                    onHide={() => ClearlanguageAddToDb()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title as="h5">Add New Language</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Row>
                        <Form.Group className="col-md-12 form-group">
                          <Form.Label htmlFor="lname">
                            Language Name:
                          </Form.Label>
                          <Form.Control
                            id="LanguageNameToAdd"
                            name="LanguageNameToAdd"
                            placeholder="Language Name"
                            type="text"
                            value={languageAddToDb.LanguageName}
                            onChange={handleAddInputs}
                          />
                        </Form.Group>
                      </Row>

                      <Row>
                        <Form.Group className="col-md-12 form-group">
                          <Form.Label htmlFor="lname">
                            Language Suffix:
                          </Form.Label>
                          <Form.Control
                            id="LanguageSuffixToAdd"
                            name="LanguageSuffixToAdd"
                            placeholder="Language Suffix"
                            type="text"
                            value={languageAddToDb.LanguageSuffix}
                            onChange={handleAddSuffixInputs}
                          />
                        </Form.Group>
                      </Row>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => SetAddModalShow(false)}
                      >
                        Close
                      </Button>
                      <Button
                        variant="primary"
                        onClick={() => AddNewLanguage()}
                      >
                        Save changes
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default LanguagesList;
